import classNames from "classnames";
import { ReactNode } from "react";
import { Icon } from "../icon/icon";

export const CTASection = ({
  icon,
  title,
  text,
  titleClassName = "",
  iconClassName = "",
  extraClassName = "",
  extra,
  onClick,
  disabled = false,
  className = "",
  showCaret = true,
}: {
  icon: string;
  title: ReactNode;
  text: ReactNode;
  titleClassName?: string;
  iconClassName?: string;
  extraClassName?: string;
  extra?: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  showCaret?: boolean;
}) => {
  return (
    <button
      className={`flex w-full items-start gap-4 text-left font-bold text-grey-900 disabled:cursor-not-allowed ${className}`}
      type="button"
      onClick={onClick}
      disabled={disabled}
    >
      <Icon
        className={classNames("min-w-fit text-primary", iconClassName)}
        svg={icon}
        width={20}
        height={20}
      />

      <div className={"flex flex-1 flex-col"}>
        {title && (
          <div className={classNames("text-base", titleClassName)}>{title}</div>
        )}
        {text && <div className="text-sm font-normal">{text}</div>}
      </div>

      <div className={classNames("self-center", extraClassName)}>{extra}</div>

      {showCaret && (
        <Icon
          className="my-auto min-w-fit -rotate-90 !self-center text-primary"
          containerClassName="self-center"
          svg="caret-down"
          width={20}
          height={20}
        />
      )}
    </button>
  );
};
